import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Segment, Dimmer, Loader } from 'semantic-ui-react'
import { get } from 'lodash'

import DateField from '../../components/adminReport/fields/dateRangeSearchField'
import DownloadButton from '../../lib/DownloadFileButton'

import DriverTransactionActions from '../../reducers/driverTransactionReducer'

class DriverTransactionReport extends React.PureComponent {
  state = {
    startFrom: Number(moment().add(-7, 'day').startOf('day').format('x')),
    endAt: Number(moment().endOf('day').format('x')),
    readyToDownload: false,
  }

  componentDidUpdate(prevProps) {
    const { loading } = this.props
    const { loading: prevLoading } = prevProps
    const { readyToDownload } = this.state

    if (!readyToDownload && prevLoading && !loading)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ readyToDownload: true })
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    const errors = []
    if (startFrom > endAt) {
      errors.push({ type: 'Date Invalid', value: 'Date invalid, please check it again' })
    }

    return { errors }
  }

  onSearch = () => {
    const { startFrom, endAt } = this.state
    const { getTransactions } = this.props
    const validation = this.validateSearchByDate()

    if (validation.errors.length < 1) {
      getTransactions(startFrom, endAt)
    } else {
      // eslint-disable-next-line no-alert
      alert(validation.errors.map(err => err.value).join(', '))
    }
  }

  getDriverTransactionData = () => {
    const { drivers, transactions } = this.props

    const renderTransactions = []
    const renderDrivers = []

    const transactionKeys = Object.keys(transactions)
    const transactionCount = transactionKeys.length

    for (let index = 0; index < transactionCount; index += 1) {
      const transactionKey = transactionKeys[index];
      const transaction = transactions[transactionKey]

      renderTransactions.push({
        'Order ID': get(transaction, 'order_id', ''),
        'Muuve\'s Number': transaction.key,
        'Description': transaction.description,
        'Amount': transaction.amount,
        'Date': moment(transaction.created_at).format('DD-MMM-YYYY'),
        'Time': moment(transaction.created_at).format('HH:mm:ss'),
      })
    }

    const driverKeys = Object.keys(drivers)
    const driverCount = driverKeys.length

    for (let index = 0; index < driverCount; index += 1) {
      const driverKey = driverKeys[index]
      const driver = drivers[driverKey]

      renderDrivers.push({
        'Muuver\'s Number': driverKey,
        'Credit Balance': parseFloat(driver.credit_balance || 0).toFixed(2),
        'Cash Balance': parseFloat(driver.cash_balance || 0).toFixed(2),
        'Total Balance': parseFloat(Number(driver.credit_balance || 0) + Number(driver.cash_balance || 0)).toFixed(2)
      })
    }

    return {
      'Muuver Wallet\'s Transaction': renderTransactions,
      'Muuver\'s Balance': renderDrivers
    }
  }

  render = () => {
    const { startFrom, endAt, readyToDownload } = this.state
    const { loading } = this.props

    const startFromFormat = moment(startFrom).format('YYYY-MMM-DD')
    const endAtFormat = moment(endAt).format('YYYY-MMM-DD')

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        {loading && (
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        )}
        <div style={{ padding: '0px 14px' }}>
          <DateField
            startFrom={startFrom}
            endAt={endAt}
            loading={loading}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
          <div
            style={{
              height: 500,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <DownloadButton
              path={`report/driver-transactions-${startFromFormat}-to-${endAtFormat}.xlsx`}
              getData={this.getDriverTransactionData}
              disabled={loading || !readyToDownload}
            />
          </div>

        </div>
      </Segment>
    )
  }
}

const mapState = ({ driverTransactions }) => ({
  loading: driverTransactions.loading,
  drivers: driverTransactions.drivers,
  transactions: driverTransactions.transactions
})

const mapDispatch = {
  getTransactions: DriverTransactionActions.getTransactions,
}

export default connect(
  mapState,
  mapDispatch
)(DriverTransactionReport)



// WEBPACK FOOTER //
// ./src/containers/reports/driverTransaction.js